export enum QuoteTableView {
    Overview = "overview",
    Details = "details"
}
